import { NavLink, Outlet } from 'react-router-dom';
import { ArrowRight, BarChart3, FileText, GraduationCap, Info } from 'lucide-react';
import { usePortalData } from '../hooks/usePortalData';
import { KoursepediaLogo } from '../components/KoursepediaLogo';
import { StatusPill } from '../components/StatusPill';
import { Chatbot } from '../components/chatbot/Chatbot';

const nav = [
  { to: '/', label: 'Universities', icon: GraduationCap },
  { to: '/compare', label: 'Compare', icon: BarChart3 },
  { to: '/scripts', label: 'Sales Scripts', icon: FileText },
  { to: '/about', label: 'About', icon: Info },
];

export function AppLayout() {
  const { data } = usePortalData();

  return (
    <div className="min-h-screen bg-[#071a3a] text-white">
      <header className="sticky top-0 z-40 border-b border-white/10 bg-[#071a3a]/80 text-white backdrop-blur-2xl">
        <div className="shell flex min-h-20 flex-wrap items-center justify-between gap-4 py-3">
          <NavLink to="/" aria-label="Koursepedia home">
            <KoursepediaLogo inverted />
          </NavLink>
          <nav className="order-3 mx-auto flex w-full justify-center gap-2 overflow-x-auto rounded-2xl border border-white/10 bg-white/10 p-1.5 shadow-[0_18px_55px_rgb(0_25_70_/_30%)] backdrop-blur-xl md:order-none md:w-auto">
            {nav.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `inline-flex shrink-0 items-center gap-2 rounded-xl px-3 py-2 text-sm font-bold transition ${
                      isActive ? 'bg-sky-500 text-white shadow-[0_12px_32px_rgb(14_165_233_/_35%)]' : 'text-sky-100/75 hover:bg-white/10 hover:text-white'
                    }`
                  }
                >
                  <Icon size={16} strokeWidth={2.4} aria-hidden />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
          <div className="flex items-center gap-3">
            <div className="hidden lg:block">
              <StatusPill source={data?.source} count={data?.programs.length} />
            </div>
            <NavLink
              to="/#universities"
              className="inline-flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-sky-400 to-blue-600 px-4 text-sm font-extrabold text-white shadow-[0_14px_40px_rgb(59_130_246_/_35%)] transition hover:-translate-y-0.5 hover:shadow-[0_18px_55px_rgb(59_130_246_/_48%)]"
            >
              Explore <ArrowRight size={16} strokeWidth={2.5} aria-hidden />
            </NavLink>
          </div>
        </div>
      </header>
      <Outlet />
      <footer className="shell flex flex-col gap-2 border-t border-white/10 py-8 text-sm text-sky-100/65 md:flex-row md:items-center md:justify-between">
        <p>Koursepedia university information portal</p>
        <p>Verify current fees, policies, and approvals on official university pages.</p>
      </footer>
      <Chatbot />
    </div>
  );
}
